  import ico from "./static/asdw.png";

export const navbaritems = [
    {
      name:"ASDW",
      icon:ico
    }
  ];